import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import './fonts/Garamond/AGaramond-Regular.otf';
import './fonts/GeneralSans/GeneralSans-Regular.ttf';

import App from "./App";
import "./index.css";

 import ScrollToTop from "./components/utility/ScrollToTop"; 

ReactDOM.createRoot(document.getElementById("root")).render(
  <BrowserRouter>
     <ScrollToTop />
    <App />
  </BrowserRouter>
);
